import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  LayoutDashboard, Users, MapPin, Building2,
  ClipboardList, Calendar, FileText, Shield, LogOut, Bot, BookOpen, Send, ClipboardCheck
} from 'lucide-react';

const DD_ROLES = ['Deputy Director Public', 'Deputy Director Private', 'Deputy Director Procurement'];
const VIEW_ONLY_ROLES = ['Chairman', 'Deputy Director Admin & Finance'];

const menuItems = [
  { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard, roles: ['Super Admin', 'IT Administrator', 'Secretary'] },
  { path: '/agents/monitoring', label: 'Monitoring Agent', icon: Bot, roles: ['Secretary', 'Super Admin'], badge: 'AI' },
  { path: '/knowledge', label: 'Knowledge Base', icon: BookOpen, roles: ['Secretary', 'Super Admin'] },
  { path: '/assignments', label: 'Assignment Requests', icon: Send, roles: ['Secretary', 'Director', 'Super Admin', ...DD_ROLES] },
  { path: '/assignments/baseline-review', label: 'Baseline Review', icon: ClipboardCheck, roles: ['Secretary', 'Super Admin'] },
  { path: '/users', label: 'Users', icon: Users, roles: ['Super Admin', ...VIEW_ONLY_ROLES] },
  { path: '/districts', label: 'Districts', icon: MapPin, roles: ['Super Admin'] },
  { path: '/institutions', label: 'Institutions', icon: Building2, roles: ['Super Admin', 'Secretary', ...VIEW_ONLY_ROLES] },
  { path: '/attendance', label: 'Attendance', icon: Calendar, roles: ['Super Admin'] },
  { path: '/reports', label: 'Reports', icon: FileText, roles: ['Super Admin', 'Secretary', ...VIEW_ONLY_ROLES] },
  { path: '/audit', label: 'Audit Log', icon: Shield, roles: ['Super Admin', 'IT Administrator'] },
];

const Sidebar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const allowedItems = menuItems.filter(item =>
    item.roles.includes(user?.role)
  );

  return (
    <div className="w-64 bg-blue-900 min-h-screen flex flex-col">
      {/* Logo */}
      <div className="p-6 border-b border-blue-800">
        <div className="text-white font-bold text-xl">BBSHRRDB</div>
        <div className="text-blue-300 text-xs mt-1">FMAS v1.0</div>
      </div>

      {/* User Info */}
      <div className="p-4 border-b border-blue-800">
        <div className="text-white font-medium text-sm">{user?.fullName}</div>
        <div className="text-blue-300 text-xs">{user?.role}</div>
      </div>

      {/* Menu Items */}
      <nav className="flex-1 p-4">
        {allowedItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-1 transition text-sm
                ${isActive
                  ? 'bg-blue-700 text-white font-semibold'
                  : 'text-blue-200 hover:bg-blue-800 hover:text-white'
                }`}
            >
              <Icon size={18} />
              <span className="flex-1">{item.label}</span>
              {item.badge && (
                <span className="bg-yellow-400 text-yellow-900 text-xs font-bold px-1.5 py-0.5 rounded">
                  {item.badge}
                </span>
              )}
            </Link>
          );
        })}
      </nav>

      {/* Logout */}
      <div className="p-4 border-t border-blue-800">
        <button
          onClick={logout}
          className="flex items-center gap-3 px-4 py-3 rounded-lg text-blue-200 hover:bg-blue-800 hover:text-white transition text-sm w-full"
        >
          <LogOut size={18} />
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;